package model

import kotlinx.serialization.Serializable

@Serializable
data class Payments(
    val orderPayment: List<OrderPayment> = emptyList()
)